import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "./Button";
import Table from "./Table";

import ClaimContext from "../../contexts/ClaimContext";

export default function Index({
  role,
  isPossibleAddClaim,
  editIcon,
  deleteIcon,
}) {
  return (
    <ClaimContext>
      <div className="wrapper_assestment invite_wrapper">
        <div className="invite_header">
          <div className="text_h3">Talent Insurance</div>
        </div>
        {role == "team_lead" && (
          <Row>
            <Col xs={8}>
              LeggUP Talent Insurance allows you to submit a claim for any
              employee who completed a LeggUP Program. For policy details click
              <a
                className="blue"
                href="https://help.leggup.com/en/articles/6622981-talent-insurance-refund-policy"
                target="_blank"
              >
                &nbsp;here
              </a>
              .
            </Col>
            <Col xs={4}>
              <div class="pull-right">
                <Button isPossibleAddClaim={isPossibleAddClaim} />
                <div>File A New Claim</div>
              </div>
            </Col>
          </Row>
        )}

        <div className="ibox-content mt20">
          <Table role={role} editIcon={editIcon} deleteIcon={deleteIcon} />
        </div>
      </div>
    </ClaimContext>
  );
}
